/** Stable colors for finance categories — matches the Figma palette used by the sample dashboard. */
export const FINANCE_CATEGORY_COLORS: Record<string, string> = {
  GROSS: '#b437dc',
  PAYOUT: '#18a9e6',
  TOTAL: '#19a9f2',
  SUBSCRIBE: '#f43f4f',
  TIP: '#43d169',
  REFERRAL: '#f4b51e',
  EXCLUSIVE: '#cb55bc',
  MESSAGE: '#9b45ef',
  LIVESTREAM: '#20aee8',
  Purchases: '#41d46b',
  Tips: '#9c4de8',
  Subscriptions: '#d957b7',
  'Live stream': '#f5b51b',
  Referrals: '#87d9ed',
  Posts: '#cb55bc',
  Messages: '#9b45ef',
  Revenue: '#b437dc',
  'Gross Revenue': '#b437dc',
  'Gross Transaction Value': '#b437dc',
  Payouts: '#18a9e6',
  'Creator Payouts': '#18a9e6',
  'Creator Earnings': '#18a9e6',
  'Total Payout': '#19a9f2',
  'GROSS_REVENUE': '#b437dc',
  'PLATFORM_REVENUE': '#9b45ef',
  'CREATOR_PAYOUTS': '#18a9e6',
  'PAID_TO_CREATORS': '#20aee8',
  'PROVIDER_FEES': '#f43f4f',
  'NET_SETTLEMENT': '#43d169',
  PAID: '#20aee8',
  PENDING: '#f4b51e',
  FAILED: '#f43f4f',
  ON_HOLD: '#7a7a78',
  STRIPE: '#635bff',
  INCENTIVES: '#f4b51e',
  APPLE: '#a2aaad',
  BANK: '#87d9ed',
};

export function financeColor(key: string | undefined | null, fallback = '#7a7a78'): string {
  if (!key) return fallback;
  return FINANCE_CATEGORY_COLORS[key] ?? fallback;
}

export const financeRangeOptions = [
  { value: 'all', label: 'All the time' },
  { value: '1', label: 'Last 24 hours' },
  { value: '7', label: 'Last 7 days' },
  { value: '30', label: 'Last 30 days' },
  { value: '60', label: 'Last 60 days' },
  { value: '90', label: 'Last 90 days' },
  { value: '180', label: 'Last 180 days' },
  { value: '365', label: 'Last 365 days' },
] as const;

export const financeCurrencyOptions = [
  { value: 'AUD', label: 'AUD', detail: 'Australian dollar · reporting currency' },
  { value: 'USD', label: 'USD', detail: 'US dollar · reporting currency' },
] as const;

const COUNTRY_LABELS: Record<string, string> = {
  AU: 'Australia',
  US: 'United States',
  GB: 'United Kingdom',
  CA: 'Canada',
  NZ: 'New Zealand',
  // TM-3572: null/blank users.country_code (Stripe Connect not onboarded).
  UNASSIGNED: 'Not yet onboarded to Stripe',
};

export const UNASSIGNED_COUNTRY_CODE = 'UNASSIGNED';

export function financeCountryLabel(code: string): string {
  return COUNTRY_LABELS[code.toUpperCase()] ?? code.toUpperCase();
}

export function financeCountryOptions(availableCodes: readonly string[] = []) {
  const codes = [
    ...new Set(availableCodes.map((code) => code.trim().toUpperCase()).filter(Boolean)),
  ].sort((left, right) => {
    if (left === UNASSIGNED_COUNTRY_CODE) return 1;
    if (right === UNASSIGNED_COUNTRY_CODE) return -1;
    return left.localeCompare(right);
  });
  return [
    {
      value: '',
      label: 'All creator countries',
      detail: 'Connect country buckets + not yet onboarded · not buyer geo',
    },
    ...codes.map((code) => ({
      value: code,
      label: financeCountryLabel(code),
      detail:
        code === UNASSIGNED_COUNTRY_CODE
          ? 'No Connect country set'
          : `Creator country (Connect) · ${code}`,
    })),
  ];
}
